import {useContext, useEffect, useState} from 'react'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'
import Search from '../../../../components/Search'
import {isEmpty} from '../../../../utils/common'
import ExportCSVButton from '../../components/ExportCSVButton'
import {ProfitabilityContext} from '../../context'
import useGetJobData from '../../../jobs/hooks/useGetJobData'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import { MIN_DATE_RANGE } from '../../utils'

const ProfitabilityHeader = () => {
  const {
    isFullView,
    onDateChangeCustomers,
    onDateChangeCustomersGroups,
    onDateChangeProfitabilitySummary,
    onDateChangeCustomersGroupsChart,
    onSearch,
    customerGroups,
    isCustomerGroupsLoading,
    onChangeCustomerGroupFilter,
    salesReps,
    isSalesRepDropdownLoading,
    onChangeSalesRepFilter,
    setDateRangeLable,
    onDownloadCSV,
    onOrdersOverviewDateChange,
    isLoading,
    profitabilityData,

    allEntityPerformanceChartData,
    isAllEntityPerformanceChartDataLoading,
    onAllEntityPerformanceChartIdChange,
    onAllEntityPerformanceChartViewChange,
    onAllEntityPerformanceChartDateRangeChange,
    allEntityPerformanceChartFilters,
  } = useContext(ProfitabilityContext)

  const [showChartModal, setShowChartModal] = useState(false)

  const {jobData, runTask, refetchJobData} = useGetJobData(
    'update_all_profitability_related_tables'
  )

  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const handleDateChange = (startDate: any, endDate: any) => {
    onDateChangeCustomers(startDate, endDate)
    onDateChangeCustomersGroups(startDate, endDate)
    onDateChangeProfitabilitySummary(startDate, endDate)
    onDateChangeCustomersGroupsChart(startDate, endDate)
    onOrdersOverviewDateChange(startDate, endDate)
  }

  useEffect(() => {
    let intervalId: any = null
    if (jobData?.status === 'running') {
      intervalId = setInterval(() => {
        refetchJobData()
      }, 30000)
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobData?.status === 'running', refetchJobData])

  return (
    <div className='mb-10'>
      <div className={`d-flex align-items-end justify-content-between gap-5`}>
        {!isFullView && (
          <div className='d-flex justify-content-center align-items-center'>
            <button
              onClick={() => setShowChartModal(true)}
              className='btn btn-outline'
            >
              <i className='fas fa-chart-line text-primary me-2'></i>
              <span className='text-center'>Profit Chart</span>
            </button>
          </div>
        )}
        {isFullView && (
          <div className='d-flex justify-content-between align-items-end w-100'>
            <div className='d-flex align-items-end gap-10'>
              <Search
                onSearch={(searchTerm: string) => {
                  onSearch && onSearch(searchTerm)
                }}
              />
              <MultiSelect
                id={`customer-group-filter`}
                label='Customer Group'
                options={customerGroups}
                className='w-175px'
                placeholder='Select Customer Group'
                allValuesSelectedText={'Customer Group: All'}
                isLoading={isCustomerGroupsLoading}
                handleSelected={onChangeCustomerGroupFilter}
              />
              <MultiSelect
                id={`sales-rep-filter`}
                label='Sales Rep'
                options={salesReps}
                className='w-175px'
                placeholder='Select Sales Rep'
                allValuesSelectedText={'Sales Rep: All'}
                isLoading={isSalesRepDropdownLoading}
                handleSelected={onChangeSalesRepFilter}
              />
            </div>
            <ExportCSVButton
              onExportCSV={onDownloadCSV}
              isLoading={isLoading}
              hide={isEmpty(profitabilityData)}
            />
          </div>
        )}
        <div className='d-flex gap-5'>
          {!isFullView && (
            <button
              onClick={() => runTask('update_all_profitability_related_tables')}
              className='btn btn-outline'
            >
              <div className='d-flex align-items-center'>
                {jobData?.status === 'running' ? (
                  <span className='spinner-border spinner-border-sm align-middle me-2'></span>
                ) : (
                  <i className='fas fa-sync cursor-pointer fs-5 me-2'></i>
                )}
                {jobData?.status === 'running' ? 'Syncing...' : 'Sync Data'}
              </div>
            </button>
          )}

          <div className='w-200px'>
            <PredefinedDateRange
              cb={handleDateChange}
              getLbl={setDateRangeLable}
              defaultValue={dateRangeLabel || 'Last 90 Days'}
              includeCurrantDay={true}
              startDate={MIN_DATE_RANGE}
            />
          </div>
        </div>
      </div>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={' '}
          entityPerformanceChartData={allEntityPerformanceChartData}
          entityName={`Profitability Report - All`}
          onEntityPerformanceChartIdChange={onAllEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onAllEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={onAllEntityPerformanceChartDateRangeChange}
          entityPerformanceChartFilters={allEntityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isAllEntityPerformanceChartDataLoading}
          startDate={MIN_DATE_RANGE}
        />
      )}
    </div>
  )
}

export default ProfitabilityHeader
